
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

interface DebugData {
  rawUsers: any;
  filteredCount?: number;
  recentCount?: number;
  searchQuery: string;
  adminUsers: string[];
  error: any;
  adminInfo: {
    isAdmin: boolean;
    uid: string | null;
  };
}

interface DebugInfoPanelProps {
  showDebugInfo: boolean;
  debugData: DebugData;
  handleRefresh: () => void;
}

export const DebugInfoPanel = ({ 
  showDebugInfo, 
  debugData, 
  handleRefresh 
}: DebugInfoPanelProps) => {
  
  if (!showDebugInfo) return null;

  return (
    <Alert>
      <AlertTitle>Debug Information</AlertTitle>
      <AlertDescription>
        <div className="mt-2 max-h-40 overflow-auto rounded bg-slate-50 p-2 text-xs">
          <pre>{JSON.stringify(debugData, null, 2)}</pre>
        </div>
      </AlertDescription>
    </Alert>
  );
};
